import React, { useState, useEffect } from "react";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { MachineInfoApi } from "./api";
import Spinner from "../Common/Components/spinner";
import HistoryGrid from "./HistoryGrid";

type handler = () => void;
interface settingsProps {
  visible: boolean;
  toggleVisible: handler;
  nodeId: number;
}

const HistoryDialog = (props: settingsProps) => {
  const [history, updateHistory] = useState(null);
  const [historyLoading, updateLoadingHistory] = useState(true);
  const [errorMessage, setErrorMessage] = useState(null);

  useEffect(() => {
    if (props.nodeId != null) {
      fetchMachineCardHistory();
    }
  }, [props.nodeId]);

  const fetchMachineCardHistory = () => {
    let params: any = { nodeId: props.nodeId };
    MachineInfoApi.getMachineCardHistory(params)
      .then((response: any) => {
        updateHistory(response);
        updateLoadingHistory(false);

        setErrorMessage(null);
      })
      .catch((error) => {
        updateLoadingHistory(false);
        setErrorMessage("Oops something went wrong, unable to get data.");

        console.log(error);
      });
  };

  const renderHistoryGrid = () => {
    if (props.nodeId == null) {
      return <div>No Id found</div>;
    }
    if (historyLoading) {
      return <Spinner text="History Data" />;
    } else {
      return <HistoryGrid data={history} />;
    }
  };

  const renderDialog = () => {
    if (props.visible) {
      return (
        <Dialog
          title={"Machine Card History"}
          onClose={props.toggleVisible}
          width={800}
          height={700}
        >
          <div style={{ backgroundColor: "#fff", padding: "20px" }}>
            {renderHistoryGrid()}
          </div>
          <DialogActionsBar>
            <button
              className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
              onClick={props.toggleVisible}
            >
              Close
            </button>
          </DialogActionsBar>
        </Dialog>
      );
    }
    return null;
  };
  return renderDialog();
};

export default HistoryDialog;
